import { connect } from 'react-redux';

import Breadcrumbs from '../components/Breadcrumbs';
import type { BreadcrumbItem } from '../components/breadcrumbLogic';

interface RootState {
  breadcrumbs?: {
    items: BreadcrumbItem[];
  };
}

const mapStateToProps = (state: RootState) => ({
  breadcrumbs: state.breadcrumbs?.items,
});

export default connect(mapStateToProps)(Breadcrumbs);
